import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'

interface Props {
    positive: number
    negative: number
}

export const SentimentChart = ({ positive, negative }: Props): JSX.Element => {
    // 為 Recharts 準備資料（完整圓形）
    const chartData = [
        { name: '正向評論', value: positive, color: '#7da387' },
        { name: '負向評論', value: negative, color: '#929084' }
    ]

    // 自定義標籤渲染
    const renderCustomLabel = (props: any) => {
        const { cx, cy, midAngle, outerRadius, value } = props
        const RADIAN = Math.PI / 180
        const radius = outerRadius + 30
        const x = cx + radius * Math.cos(-midAngle * RADIAN)
        const y = cy + radius * Math.sin(-midAngle * RADIAN)

        return (
            <text
                x={x}
                y={y}
                fill="#373737"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
                className="[font-family:'Noto_Sans_TC',Helvetica] font-bold"
                fontSize="20"
            >
                {value}%
            </text>
        )
    }

    return (
        <div className="w-full h-full relative">
            {/* Recharts 完整圓餅圖 */}
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={80}
                        paddingAngle={2}
                        dataKey="value"
                        label={renderCustomLabel}
                        labelLine={{ stroke: '#999', strokeWidth: 1 }}
                        animationBegin={0}
                        animationDuration={800}
                        startAngle={90}
                        endAngle={450}
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke="white" strokeWidth={3} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>

            {/* 圖例 */}
            <div className="absolute top-0 left-[11.54%] w-[31.26%] h-[8.99%]">
                <div className="absolute w-[67.01%] h-[95.00%] top-[5.00%] left-[31.08%] flex items-center justify-center [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#373737] text-base tracking-[1.60px] leading-[normal]">
                    正向評論
                </div>
                <div className="absolute w-[19px] h-[19px] top-1 left-0 bg-[#7da387] rounded-full" />
            </div>

            <div className="absolute top-0 left-[54.65%] w-[31.87%] h-[8.99%]">
                <div className="absolute w-[65.74%] h-[95.00%] top-[5.00%] left-[32.39%] flex items-center justify-center [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#373737] text-base tracking-[1.60px] leading-[normal]">
                    負向評論
                </div>
                <div className="absolute w-[19px] h-[19px] top-1 left-0 bg-[#929084] rounded-full" />
            </div>
        </div>
    )
}

export default SentimentChart